/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientSurveySections from './patient-survey-sections';
import PatientSurveySectionsDetail from './patient-survey-sections-detail';
import PatientSurveySectionsUpdate from './patient-survey-sections-update';
import PatientSurveySectionsDeleteDialog from './patient-survey-sections-delete-dialog';

const PatientSurveySectionsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientSurveySections />} />
    <Route path="new" element={<PatientSurveySectionsUpdate />} />
    <Route path=":id">
      <Route index element={<PatientSurveySectionsDetail />} />
      <Route path="edit" element={<PatientSurveySectionsUpdate />} />
      <Route path="delete" element={<PatientSurveySectionsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientSurveySectionsRoutes;
